import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

function ProductDetailAttributeCard({ name, value }) {
	return (
		<Grid item xs={12} aria-label="specs details">
			<Typography
				variant="heading8"
				tabIndex={0}
				aria-label={name}
				role="paragraph"
			>
				{name}
			</Typography>

			<Grid item xs={6} mt={-0.35}>
				<Typography
					variant="caption1"
					tabIndex={0}
					aria-label={value}
					role="paragraph"
				>
					{value}
				</Typography>
			</Grid>
		</Grid>
	);
}

ProductDetailAttributeCard.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
};

export default ProductDetailAttributeCard;
